import FeaturedPodcasts from './FeaturedPodcasts';

export default FeaturedPodcasts;
